const RANKING_ITEMS = [
  { rank: 1, title: '繁华似锦', type: '大陆剧', episodes: '全40集', heat: '9.8', tag: '热播' },
  { rank: 2, title: '逆光之恋', type: '韩剧', episodes: '更新至16集', heat: '9.6', tag: '新剧' },
  { rank: 3, title: '长安十二时辰', type: '大陆剧', episodes: '全48集', heat: '9.5', tag: '高分' },
  { rank: 4, title: '秘密森林第三季', type: '韩剧', episodes: '全16集', heat: '9.4', tag: '完结' },
  { rank: 5, title: '风起洛阳', type: '大陆剧', episodes: '全39集', heat: '9.3', tag: '经典' },
  { rank: 6, title: '请回答2028', type: '韩剧', episodes: '全20集', heat: '9.2', tag: '推荐' },
  { rank: 7, title: '山海情', type: '大陆剧', episodes: '全23集', heat: '9.1', tag: '口碑' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100/60 text-accent-700 text-xs font-medium mb-4">
              实时榜单
            </span>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading">
              热门剧集排行榜
            </h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
              根据观看热度与用户评分实时更新，发现大家都在追的好剧
            </p>
          </div>

          <div className="space-y-3">
            {RANKING_ITEMS.map((item) => (
              <div
                key={item.rank}
                className="group flex items-center gap-3 md:gap-5 p-3 md:p-4 bg-background-50 rounded-xl border border-background-200/40 hover:border-primary-500/30 hover:bg-background-100/70 transition-all duration-200 cursor-pointer"
              >
                <div className={`w-8 h-8 md:w-10 md:h-10 flex-shrink-0 flex items-center justify-center rounded-lg font-bold text-sm md:text-base ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-200 text-foreground-500'
                }`}>
                  {item.rank}
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <h3 className="text-sm md:text-base font-semibold text-foreground-950 whitespace-nowrap">{item.title}</h3>
                    <span className="text-xs px-2 py-0.5 rounded-full bg-primary-100/70 text-primary-600 font-medium whitespace-nowrap">{item.tag}</span>
                  </div>
                  <div className="flex items-center gap-3 mt-1">
                    <span className="text-xs text-foreground-500">{item.type}</span>
                    <span className="text-xs text-foreground-400">|</span>
                    <span className="text-xs text-foreground-500">{item.episodes}</span>
                  </div>
                </div>

                <div className="flex items-center gap-1 text-accent-500">
                  <span className="text-lg md:text-xl font-bold font-heading">{item.heat}</span>
                  <span className="text-xs text-foreground-400">分</span>
                </div>

                <div className="hidden sm:flex items-center gap-1 text-foreground-400 group-hover:text-primary-400 transition-colors">
                  <i className="ri-play-circle-line text-xl"></i>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}